<ng-container *transloco="let t">
  <div iCard direction="vertical">
    <div iCardHeader class="flex flex-col gap-6 pb-0 sm:pb-0 md:flex-row md:items-center">
      <div class="flex flex-1 items-center justify-between gap-4">
        <div>
          <div class="type-body-medium text-foreground">{{ t("billing-settings.billable_ad_spend") }}</div>
          @if (nextInvoiceDate()) {
            <div class="type-label text-muted-foreground">
              {{
                t("billing-settings.billable_ad_spend_subtitle", {
                  date: nextInvoiceDate() | date: "longDate" : undefined : locale(),
                })
              }}
            </div>
          }
        </div>
        <div class="type-body flex items-center gap-3">
          @let billableAdSpend = adSpend();
          @if (billableAdSpend === undefined) {
            <div class="h-5 w-16 animate-pulse rounded-md bg-gray-200"></div>
          } @else {
            <span class="text-foreground">{{
              billableAdSpend | currency: currency() : "symbol" : "1.2-2" : locale()
            }}</span>
          }
          <button
            iButton
            variant="secondary"
            size="icon-sm"
            [iTooltip]="t('billing-settings.details_by_account')"
            [disabled]="billableAdSpend === undefined"
            (click)="openSpendByAccount()"
          >
            <IIcon name="search" />
          </button>
        </div>
      </div>
      @let gauge = keywordTrackerGauge();
      @if (gauge) {
        <div class="flex flex-col gap-3 md:w-72 md:border-l md:border-gray-200 md:pl-6">
          <div class="flex items-center justify-between gap-4">
            <div class="type-body-medium text-foreground">{{ t("billing-settings.tracked_keywords") }}</div>
            <button
              iButton
              variant="secondary"
              size="icon-sm"
              [iTooltip]="t('billing-settings.details_by_account')"
              [disabled]="gauge.used === undefined"
              (click)="openTrackedKeywordsByAccount()"
            >
              <IIcon name="search" />
            </button>
          </div>
          @if (gauge.used === undefined) {
            <div class="h-4 w-20 animate-pulse rounded-md bg-gray-200"></div>
          } @else {
            <div class="type-label text-foreground">
              {{ gauge.used | number: "1.0-0" : locale() }}
              @if (gauge.limit) {
                <span class="text-muted-foreground">/ {{ gauge.limit | number: "1.0-0" : locale() }}</span>
              }
            </div>
            @if (gauge.limit) {
              <IProgressBar [progress]="gauge.used / gauge.limit" />
            }
          }
        </div>
      }
    </div>
  </div>
</ng-container>
